export default __webpack_public_path__ + "static/media/tennisBall.d2cf3a36.png";